import NavigationMenu from "./NavigationMenu";
import MyLogo from "../../Media/stalkerig_logo.png";

const Header = () => {
    return (
        <>
            <header className="main-header">
                <article className="web-header">
                    <section className="logo-section">
                        <img
                            src={MyLogo}
                            alt="Web App Logo"
                            className="myLogo"
                        />
                    </section>
                    <h1 className="web-name"> HannanMaxIG </h1>
                    <h4 className="web-name"> Made with ❤️ by Hannan Max aka Hannanahmad Shaikh</h4>
                </article>
                <nav>
                    <NavigationMenu />
                </nav>
            </header>
        </>
    );
};

export default Header;
